export enum BrazeEvents {
  purchase_complete = 'purchase_complete',
}

export enum BrazeUserAttributes {
  saved_card = 'saved_card',
  currency = 'currency',
  total_value = 'total_value',
  shipping = 'shipping',
  transaction_id = 'transaction_id',
  payment_mode = 'payment_mode',
  promo_code = 'promo_code',
  promo_type = 'promo_type',
  order_type = 'order_type',
  last_viewed_page = 'last_viewed_page',
  cart_count = 'cart_count',
}
